<div class="filter" [ngClass]="{ 'dark-filter': isDarkMode() }">
  <form [formGroup]="filterForm">
    <div class="filterRow">
      <div class="col">
        <app-custom-date-picker
          [label]="'From Date:'"
          [controlname]="this.filterForm.controls['from_date']"
        ></app-custom-date-picker>
      </div>
      <div class="col">
        <app-custom-date-picker
          [label]="'To Date:'"
          [controlname]="this.filterForm.controls['to_date']"
        ></app-custom-date-picker>
      </div>
      <div class="col">
        <app-custom-dropdown
          [label]="'Segment:'"
          [items]="segmentOptions"
          [controlname]="this.filterForm.controls['segment']"
        ></app-custom-dropdown>
      </div>
      <div class="col">
        <app-custom-dropdown
          [label]="'Condition:'"
          [items]="conditionOptions"
          [controlname]="this.filterForm.controls['condition']"
        ></app-custom-dropdown>
      </div>
      <div class="filterBtn col-md1">
        <button class="btn bc hover-button apply" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon>
          <span class="name">Clear Filter</span>
        </button>
      </div>
      <div class="filterBtn">
        <button class="btn btn-light hover-button apply " (click)="filterClick()">
          <mat-icon class="filterIcon">filter_list</mat-icon>
          <span class="name">Apply Filter</span>
        </button>
      </div>
    </div>
  </form>
</div>
<div class="text-right topBtn" *ngIf="addRowBtn">
  <button class="btn btn-light hover-button apply" (click)="addRow()">
    <mat-icon>add</mat-icon>
    <span class="name">Add Row</span>
  </button>
</div>
<br />
<div class="table-container scroll-bar">
  <table
    class="mat-elevation-z8"
    id="style-4"
    matSort
    [ngClass]="{ 'dark-table': isDarkMode() }"
  >
    <thead class="fixed-header">
      <tr>
        <th mat-sort-header="sNo">S.No</th>
        <th><span>From</span></th>
        <th><span>To</span></th>
        <!-- <th>Month</th> -->
        <th>Segment</th>
        <th *ngIf="username === 'Meraki - Operations'  && subusername !== 'demo'">Client</th>
        <th>Condition</th>
        <th *ngIf="generateReport">Generate Report</th>
        <th>View</th>
        <!-- <th>Status</th> -->
      </tr>
    </thead>
    <tbody>

      <ng-container *ngIf="isLoadingTable">
    <tr class="skeleton-row" *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
      <td><div class="skeleton skeleton-text short"></div></td>
      <td><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-text"></div></td>
      <td><div class="skeleton skeleton-badge"></div></td>
      <td *ngIf="username === 'Meraki - Operations' && subusername !== 'demo'">
        <div class="skeleton skeleton-text"></div>
      </td>
      <td><div class="skeleton skeleton-text short"></div></td>
      <td *ngIf="generateReport"><div class="skeleton skeleton-btn"></div></td>
      <td><div class="skeleton skeleton-btn"></div></td>
    </tr>
  </ng-container>

  <ng-container *ngIf="!isLoadingTable">
      <tr *ngFor="let element of addRowdData; let rowIndex = index">
        <td>
          {{ element.sNo + rowIndex }}
        </td>
        <td>
          <div class="">
            <input
              type="date"
              class="form-control"
              autocomplete="off"
              [(ngModel)]="element.from"
            />
          </div>
        </td>
        <td>
          <div class="">
            <input
              type="date"
              class="form-control"
              autocomplete="off"
              [(ngModel)]="element.to"
            />
          </div>
        </td>
        <td>
          <select [(ngModel)]="element.segment" class="form-control">
            <option
              *ngFor="let item of segmentOptions; even as isEven; odd as isOdd"
              [value]="item"
              [ngClass]="{ odd: isOdd, even: isEven }"
            >
              {{ item }}
            </option>
          </select>
        </td>
        <td>
          <select [(ngModel)]="element.client" class="form-control">
            <option
              *ngFor="let item of clientOptions; even as isEven; odd as isOdd"
              [value]="item"
              [ngClass]="{ odd: isOdd, even: isEven }"
            >
              {{ item }}
            </option>
          </select>
        </td>
        <td>
          <select [(ngModel)]="element.condition" class="form-control">
            <option
              *ngFor="
                let item of conditionOptions;
                even as isEven;
                odd as isOdd
              "
              [value]="item"
              [ngClass]="{ odd: isOdd, even: isEven }"
            >
              {{ item }}
            </option>
          </select>
        </td>
        <td>
          <button mat-icon-button (click)="generate(element)">
            <mat-icon>description</mat-icon>
          </button>
        </td>
        <td></td>
      </tr>
      <tr *ngFor="let element of paginatedData; let rowIndex = index">
        <td>
          {{ rowIndex + 1 }}
        </td>
        <td>
          {{ element.from_date }}
        </td>
        <td>
          {{ element.to_date }}
        </td>
        <td>
            <span [ngStyle]="getDynamicSegmentStyle(element.segment)">
              {{ element.segment }}
            </span>
        </td>
         <td  *ngIf="username === 'Meraki - Operations'  && subusername !== 'demo'">
          {{ element.customer }}
        </td>
        <td>
          {{ element.vessel_condition }}
        </td>
        
        <td *ngIf="generateReport"></td>
        <td>
          <button
            mat-icon-button
            (click)="showDetails(element)"
            [disabled]="!element.pdf_link || subusername === 'demo'"
            [ngStyle]="{'color': element.pdf_link ? '#008000' : 'inherit'}"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </tr>

  </ng-container>
    
    </tbody>
  </table>
</div>
<mat-paginator
  [length]="tableData.length"
  [pageSizeOptions]="[100]"
  [pageSize]="itemsPerPage"
  (page)="onPageChange($event)"
  [ngClass]="{ 'dark-paginator': isDarkMode() }"
  showFirstLastButtons
></mat-paginator>
<div class="text-right">
  <button class="btn btn-light hover-button mail">
    <mat-icon>download</mat-icon>&nbsp; Download
  </button>
  <button class="btn btn-light hover-button mail">
    <mat-icon>print</mat-icon>&nbsp; Print
  </button>
  <button class="btn btn-light hover-button mail">
    <mat-icon>download</mat-icon>&nbsp; Export
  </button>
</div>
<br />
